import ProfileTopNavigation from './ProfileTopNavigation';
import HelpCenterSection from '../../PageComponent/ProfilePage/HelpCenterSection';

function HelpCenter() {
  return (
    <div className="text-coalBlack pb-[20%]">
      <ProfileTopNavigation pageTitle={'Help Center'} />
      <HelpCenterSection />
    </div>
  );
}

export default HelpCenter;
